import React from "react";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router";

const text_style = {
  "fontFamily":"Open Sans Hebrew", 
  "background":"rgba(204, 204, 204, 0)",
  "font-size": "14px",
  "font-weight": "bold"

}

class InfoButton extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClick() {
    if (this.props.attributes["type"] == "student") {
      this.props.history.push({
        pathname: "studentinfo",
        state: { details: this.props.attributes },
      });
    } else {
      this.props.history.push({
        pathname: "parentinfo",
        state: { details: this.props.attributes },
      });
    }
  }

  render() {
    return (
      <div>
        <Button onClick={this.handleClick.bind(this)} style={text_style}>
           פרטים נוספים 
        </Button>
      </div>
    );
  }
}

export default withRouter(InfoButton);
